import React, { useState, useEffect, Suspense } from 'react';
import classnames from 'classnames';
import { PapiEditorText } from '@wix/da-papi-types';
import CustomBoxViewer from '@wix/da-shared-react/pkg/DaEditorWrapper/Viewer/CustomBox';
import TextRenderer from '@wix/da-shared-react/pkg/TextRenderer';
import Background from '@wix/da-shared-react/pkg/Background';
import { BackgroundInfo } from '@wix/da-shared-react/pkg/Background/types';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { ZoneType } from '../../../../types/layout';
import { getMeasuredCookieType } from './helpers';

import s from './Custom.scss';

export interface Props extends BackgroundInfo {
  className?: string;
  title?: string;
  customtext: PapiEditorText;
  moduleId: number;
  moduleVersion: number;
  isOwner: boolean;
  isCurrentUserCoreMember: boolean;
  width?: string;
  viewerKeySuffix?: string;
  zone: ZoneType;
  position?: number;
  noPadding?: boolean;
  showCoreUpsell?: boolean;
}
const Custom: React.FC<Props> = props => {
  const {
    title,
    imageDeviation,
    imageUrl,
    backgroundType,
    imageDisplayMode,
    imageTint,
    pattern,
    gradient,
    color,
    moduleId,
    moduleVersion,
    viewerKeySuffix,
    zone,
    position,
    noPadding,
  } = props;
  const backgroundProps = {
    title,
    imageDeviation,
    imageUrl,
    backgroundType,
    imageDisplayMode,
    imageTint,
    pattern,
    gradient,
    color,
  };

  // Force measured cache bust any time viewerKeySuffix updates
  const [measuredVersion, setMeasuredVersion] = useState(0);
  const [viewerKey, setViewerKey] = useState(viewerKeySuffix);
  useEffect(() => {
    if (viewerKeySuffix !== viewerKey) {
      setMeasuredVersion(measuredVersion + 1);
      setViewerKey(viewerKeySuffix);
    }
  }, [viewerKeySuffix, viewerKey, measuredVersion]);

  const measuredCookieType = getMeasuredCookieType(zone, position);
  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    measuredCookieType,
    {
      cookieDim: 'width',
      version: measuredVersion,
    }
  );

  const width = measuredContainer?.width || 600;

  return (
    <>
      <Background
        variant="custombox"
        className={classnames(
          'da-editor-custombox',
          s['root'],
          props.className
        )}
        contentClassName={s['content']}
        {...backgroundProps}
        noPadding={noPadding}
      >
        <div ref={ref} style={{ width: '100%' }}>
          <Suspense fallback={null}>
            <TextRenderer
              width={width}
              textContent={props.customtext}
              reactViewer={CustomBoxViewer}
              legacyTheme={'default'}
              viewerKey={`custombox-${moduleId}-${moduleVersion}-${width}`}
            />
          </Suspense>
        </div>
      </Background>
    </>
  );
};
Custom.displayName = 'Custom';

export default Custom;
